<script setup>
import { computed, ref, watch } from 'vue'
import MixGridBlock from '@components/mix-grid-block'
import { useStore } from '@composables/use-store'

const INITIAL_RESOURCES = 30
const LOAD_MORE_THROTTLE_MS = 200
const BOTTOM_OFFSET_RATIO = 3

const props = defineProps({
    searchResults: {
        type: Object,
        default: () => {},
    },
    searchJoin: {
        type: Function,
        default: () => {},
    },
})

const store = useStore()

const visibleResources = ref(INITIAL_RESOURCES)
const shouldLoadMore = ref(true)

const mixes = computed(() => props.searchResults.Mixes)

const scroll = computed(() => store.state.appearance.scroll)

function showMoreResults() {
    props.searchJoin(INITIAL_RESOURCES, visibleResources.value, 'Mixes').then(remaining => {
        visibleResources.value = remaining
    })
}

watch(scroll, () => {
    if (mixes.value.length < visibleResources.value) return

    const bottomOfWindow =
        scroll.value + window.innerHeight >=
        store.state.appearance.scrollChild.offsetHeight - window.innerHeight / BOTTOM_OFFSET_RATIO

    if (bottomOfWindow && shouldLoadMore.value) {
        shouldLoadMore.value = false
        setTimeout(() => {
            shouldLoadMore.value = true
        }, LOAD_MORE_THROTTLE_MS)
        showMoreResults()
    }
})
</script>

<template>
    <div>
        <BaseSection
            v-if="mixes"
            padded
        >
            <MixGridBlock :mixes="mixes" />
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
